import React from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "@hooks/useNotification";
import ModalIndex from "@Modals/layout/index";
import { Employer } from "@services/all.services";

export default React.memo(function ModalActiveAccess({ onCloseClicked, show }) {
  const { t } = useTranslation("beginEnd.protocol");
  const { showError, showSuccess } = useNotification();

  function onActivate() {
    Employer.updateById({
      _id: 0,
      activationFunction: true,
      enterpriseId: localStorage.getItem("enterpriseId")
    })
      .then((response) => {
        if (response.status === 200) {
          showSuccess(
            "Employé activé avec succès Un courriel lui permettant de se connecter vient de lui être envoyé"
          );
        }
      })
      .catch((error) => {
        console.log(error);
        showError("error");
      })
      .finally(() => {
        onCloseClicked();
      });
  }

  return (
    <ModalIndex  
      isOpen={show}
      onClickClose={onCloseClicked}
      buttonOptions={{
        click: onActivate,
        color: "green",
        title: t("Activer")
      }}
      buttonCancelOptions={{
        click: onCloseClicked,
        color: "outlined",
        title: t("Annuler")
      }}
    >
      <h3 className="arh-px-6 arh-text-2xl arh-font-poppins arh-font-semibold arh-text-darkColor">
        {t("Êtes-vous sûr de vouloir activer tous les employés")} ?
      </h3>
    </ModalIndex  >
  );
});
